import { TaxFiling } from '@fruitful/types';

// 2025 Standard Deductions by Filing Status
export const STANDARD_DEDUCTIONS: Record<TaxFiling, number> = {
    [TaxFiling.SINGLE]: 14_600,
    [TaxFiling.MARRIED_FILING_JOINTLY]: 29_200,
    [TaxFiling.HEAD_OF_HOUSEHOLD]: 21_900,
    [TaxFiling.MARRIED_FILING_SEPARATELY]: 14_600,
};
